export default "__VITE_ASSET__W8Rxv2BR__"